import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getConfigCiTestCasesRequest } from "./api";
import { configCiTestCasesSelector } from "./selectors";
import { getConfigCiTestCases, setConfigCiTestCases } from "./actions";

const configCiTestCasesSchema = new schema.Entity("config_ci_test_cases", {}, { idAttribute: "code" });
const configCiTestCasesSchemaListSchema = new schema.Array(configCiTestCasesSchema);

export function* getConfigCiTestCasesWorker() {
    try {
        const { codes } = yield select(configCiTestCasesSelector);

        if(!codes.length){
            yield put(setConfigCiTestCases({ isLoadingConfigCiTestCases: true }));

            const { config_ci_test_cases } = yield call(getConfigCiTestCasesRequest);
            const { result, entities } = normalize(config_ci_test_cases, configCiTestCasesSchemaListSchema);

            yield put(setConfigCiTestCases({
                isLoadingConfigCiTestCases: false,
                configCiTestCases: entities.config_ci_test_cases,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setConfigCiTestCases({ isLoadingConfigCiTestCases: false }));
        showError(error);
    }
}

export function* getConfigCiTestCasesSagas() {
    yield all([
        yield takeLatest(getConfigCiTestCases, getConfigCiTestCasesWorker)
    ]);
}
